import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07d24672"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-content mt-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar bg-primary-100 col-span-1 rounded w-2" }, null, -1))
const _hoisted_3 = { class: "items" }
const _hoisted_4 = { class: "flex tab-label rounded-lg secondary mt-2" }
const _hoisted_5 = { class: "text-gray-200 pt-4 pb-4 text-left pl-4 text-base md:text-base lg:text-base" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("header", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, [
          _renderSlot(_ctx.$slots, "answer", {}, undefined, true)
        ])
      ])
    ])
  ]))
}